exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cashboxbutton[data-v-54522906]{bottom:15px;position:fixed;z-index:38;right:15px;box-shadow:5px 0 13px 3px rgba(0,0,0,.1);border-radius:20px}.notification[data-v-54522906]{padding:15px;margin-bottom:15px}.selected[data-v-54522906]{box-shadow:0 3px 6px #c9c9c9}.numero[data-v-54522906]{font-size:14px;padding:3px 7px;width:27px;border-radius:20px}.datospruducto table[data-v-54522906],.datospruducto td[data-v-54522906],.datospruducto th[data-v-54522906]{font-size:14px;padding-left:3px!important;padding-right:3px!important;color:#fff!important}.datospruducto tfoot[data-v-54522906]{border:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54522906","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/facturar/Facturar.vue
// module id = 687
// module chunks = 0